export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_SELECTED_NOTIFICATION_ID = 'SET_SELECTED_NOTIFICATION_ID'
export const SET_NOTIFICATION_READ = 'MARK_NOTIFICATION_AS_READ'